import React from "react";
import "./Footer.css";
const Footer = () => {
  return (
    <div className="footer">
      <h6>Coded by: Kene Ojukwu</h6>
    </div>
  );
};

export default Footer;
